var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-page-header"},[_c('BaseIconButton',{class:{
        'header-button-blurred': _vm.imagePresent
    },attrs:{"variant":"fill","icon":"arrow-left","size":"md","textColor":_vm.buttonStyles.text,"bgColor":_vm.buttonStyles.bg},on:{"click":function($event){return _vm.$emit('back')}}}),_c('BaseIconButton',{class:{
        'header-button-blurred': _vm.imagePresent
    },attrs:{"variant":"fill","icon":"share-02","size":"md","textColor":_vm.buttonStyles.text,"bgColor":_vm.buttonStyles.bg},on:{"click":function($event){return _vm.$emit('share')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }